import axios from "axios";

const loggingApi = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/api`,
});

loggingApi.interceptors.request.use((config) => {
  if (!localStorage.getItem('userAnonId')) {
    localStorage.setItem('userAnonId', crypto.randomUUID());
  }
  config.headers['x-user-anon-id'] = localStorage.getItem('userAnonId');

  // Set JWT Bearer token if available
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }

  return config;
}, (error) => {
  return Promise.reject(error);
});

export default loggingApi;
